import { PayloadAction } from '@reduxjs/toolkit';
import { ChangePdfImageParams, PageChangeActionType } from '@v2/components/imageHandling/types/types.d';
import { ImageHandlingState } from '@reducers/v2/imageHandlingV2/imageHandlingV2.slice';

export const changePDFImageAction = (state: ImageHandlingState, action: PayloadAction<ChangePdfImageParams>) => {
  const { contextKey, contentHash, pageChangeActionType } = action.payload;
  const currentContextStore = state.imagesDocumentsContexts[contextKey];
  if (!currentContextStore) {
    return;
  }
  const isNextPage = pageChangeActionType === PageChangeActionType.NEXT;

  // Update documents in the dictionary for this context
  currentContextStore.documentIds.forEach((docId) => {
    const image = state.imagesDocumentsDict[docId];
    if (!image || image.contentHash !== contentHash) return;

    const newPage = isNextPage ? Math.min(image.pageNumber + 1, image.pageCount) : Math.max(image.pageNumber - 1, 0);
    const links = image.pagesList?.[newPage] ?? image.links;

    // Update the document in the dictionary
    state.imagesDocumentsDict[docId] = { ...image, pageNumber: newPage, ...links };
  });
};
